import { render, staticRenderFns } from "./ConsultarEventos.vue?vue&type=template&id=7946397b&scoped=true"
import script from "./ConsultarEventos.vue?vue&type=script&lang=ts"
export * from "./ConsultarEventos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7946397b",
  null
  
)

export default component.exports